document.querySelectorAll(".premium-carousel").forEach(carousel=>{
const autoplay=carousel.dataset.autoplay==="true";
const speed=parseInt(carousel.dataset.speed);

const track=carousel.querySelector(".premium-carousel-track");
const prev=carousel.querySelector(".left");
const next=carousel.querySelector(".right");
const dots=[...carousel.querySelectorAll(".premium-carousel-dot")];
const dotsContainer = carousel.querySelector(".premium-carousel-dots");
const fills = dots.map(dot =>
    dot.querySelector(".premium-carousel-dot-progress")
);
let activeIndex = 0;
let paused = false;
let animationStart = 0;
let remainingTime = speed;
let currentFill = null;

function slides(){
    return [...track.querySelectorAll(".premium-carousel-slide")];
}

function goToSlide(index, autoplayTrigger = true){

    const total = slides().length;

    // Infinite wrapping
    if(index < 0)
        index = total - 1;

    if(index >= total)
        index = 0;

    activeIndex = index;

    gotoSlide(index);

    activateDot(index, autoplayTrigger && !paused);

    if (paused) {

        currentFill.style.transition = "none";
        currentFill.style.transform = "scaleX(0)";

    }

}

function currentIndex(){

    const center=track.scrollLeft+track.clientWidth/2;

    let best=0;
    let dist=999999;

    slides().forEach((s,i)=>{

        const c=s.offsetLeft+s.offsetWidth/2;
        const d=Math.abs(center-c);

        if(d<dist){
            dist=d;
            best=i;
        }

    });

    return best;

}

function activateDot(index, autoplayTrigger = false){

    dots.forEach((dot,i)=>{

        dot.classList.toggle(
            "active",
            i===index
        );

    });

    fills.forEach(fill=>{

        fill.style.transition="none";
        fill.style.transform="scaleX(0)";

    });

    const fill=fills[index];

    currentFill = fill;

    remainingTime = speed;

    // Reset the new bar
    fill.style.transition = "none";
    fill.style.transform = "scaleX(0)";

    fill.offsetWidth;

    // Only start it if we're NOT paused
    if (!paused) {

        animationStart = performance.now();

        fill.style.transition =
            `transform ${remainingTime}ms linear`;

        fill.style.transform = "scaleX(1)";

    }

    fill.ontransitionend = null;

    if (autoplayTrigger) {

        fill.ontransitionend = () => {

            if (!autoplay)
                return;

            goToSlide(activeIndex + 1);

        };

    }

    const dot = dots[index];

    const target =
        dot.offsetLeft
        - dotsContainer.clientWidth / 2
        + dot.clientWidth / 2;

    dotsContainer.scrollTo({

        left: target,
        behavior: "smooth"

    });

}


function gotoSlide(i){

    const s=slides()[i];

    if(!s) return;

    track.scrollTo({

        left:s.offsetLeft-(track.clientWidth-s.offsetWidth)/2,
        behavior:"smooth"

    });

}

next.onclick = () => {

    const wasPaused = paused;

    goToSlide(activeIndex + 1);

    if (wasPaused)
        stop();

};
prev.onclick = () => {

    const wasPaused = paused;

    goToSlide(activeIndex - 1);

    if (wasPaused)
        stop();

};

dots.forEach((dot, i) => {

    dot.onclick = () => {

        activeIndex = i;

        gotoSlide(i);

        activateDot(i, true);

    };

});

function start(){

    if(!autoplay)
        return;

    if(!currentFill){

        activateDot(activeIndex,true);
        return;

    }

    if(!paused)
        return;

    paused = false;

    animationStart = performance.now();

    currentFill.offsetWidth;

    currentFill.style.transition =
        `transform ${remainingTime}ms linear`;

    currentFill.style.transform = "scaleX(1)";


}

function stop(){

    if(paused || !currentFill)
        return;

    paused = true;

    const elapsed = performance.now() - animationStart;

    remainingTime = Math.max(0, remainingTime - elapsed);

    const matrix = getComputedStyle(currentFill).transform;

    currentFill.style.transition = "none";
    currentFill.style.transform = matrix;

}

track.addEventListener("mouseenter", stop);
track.addEventListener("mouseleave", start);

track.addEventListener("touchstart",stop,{passive:true});
track.addEventListener("touchend",start);

let down=false,startX,left;

track.addEventListener("mousedown",e=>{

    down=true;

    startX=e.pageX;
    left=track.scrollLeft;

    stop();

});

window.addEventListener("mouseup",()=>{

    down=false;
    start();

});

track.addEventListener("mousemove",e=>{

    if(!down)
        return;

    e.preventDefault();

    track.scrollLeft=left-(e.pageX-startX);

});

document.addEventListener("keydown",e=>{

    if(e.key==="ArrowRight")
        next.click();

    if(e.key==="ArrowLeft")
        prev.click();

});

activeIndex = currentIndex();

goToSlide(activeIndex);

});